module.exports = __webpack_public_path__ + "img/w31.fa94d456.svg";